"use client";

import { usePathname } from "next/navigation";
import { isMarketingHost, isMarketingPath } from "@/core/marketing/marketing-host";
import { SUPPORT_LINKS } from "@/core/support/help";

export function HelpWidget({ hostHeader }: { hostHeader: string | null }) {
  const pathname = usePathname();

  if (isMarketingHost(hostHeader) && isMarketingPath(pathname ?? "/")) return null;

  return (
    <details className="fixed bottom-4 right-4 z-30 w-64 rounded-md border border-border bg-card p-3 text-sm shadow-lg">
      <summary className="cursor-pointer font-medium">Help</summary>
      <div className="mt-3 space-y-2">
        {SUPPORT_LINKS.map((link) => (
          <a
            key={link.label}
            className="flex items-center justify-between rounded-md px-2 py-1.5 hover:bg-muted"
            href={link.href}
          >
            <span>{link.label}</span>
            {link.status === "active" ? <span className="text-xs text-muted-foreground">Open</span> : null}
            {link.status === "tbd" ? <span className="text-xs text-muted-foreground">TBD</span> : null}
            {link.status === "customer_specific" ? <span className="text-xs text-muted-foreground">Per tenant</span> : null}
          </a>
        ))}
      </div>
    </details>
  );
}
